/** @format */

const sortRequests = (key, clientsParams, prop) => {
  switch (true) {
    case key === 'NOME':
      prop = 'name';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    case key === 'TELEFONO':
      prop = 'email';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    case key === 'EMAIL':
      prop = 'email';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    case key === 'VENDITE':
      prop = 'salesNum';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    case key === 'VALORE VENDITE':
      prop = 'salesNum';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    case key === 'ATTIVO DA':
      prop = 'timestamp';
      if (clientsParams.orderBy.prop === prop) {
        clientsParams.orderBy.direction =
          clientsParams.orderBy.direction === 'asc' ? 'desc' : 'asc';
        clientsParams.orderBy.prop = prop;
      } else {
        clientsParams.orderBy.prop = prop;
      }
      break;
    default:
  }
  return clientsParams;
};

export default sortRequests;
